import { $all as __all, createQueryOperator } from "../../_predicates";
const $all = createQueryOperator(__all);
export {
  $all
};
